import { Button, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { journalOptions } from '@/module/Nomen/Journal/model/JournalModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type JournalSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function JournalSelectControl<T extends FieldValues>(props: JournalSelectControlProps<T>) {
  const { data, isLoading, isError, refetch } = useQuery(journalOptions.getAll());
  const { t } = useTranslation();
  const [hasAddedNew, setHasAddedNew] = useState(false);

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      description={t('journals.select.limit')}
      limit={100}
      nothingFoundMessage={
        <Stack>
          <Text ta="center">{t('journals.select.nothingFound')}</Text>
          {!hasAddedNew && (
            <Button
              size="xs"
              onClick={() => {
                window.open('/journal/create');
                setHasAddedNew(true);
              }}
            >
              {t('button.add')}
            </Button>
          )}
          {hasAddedNew && <Button onClick={() => refetch()}>Refresh</Button>}
        </Stack>
      }
      options={(data ?? []).map(j => ({ id: j.id, name: j.title }))}
      {...props}
    />
  );
}
